<div class="detailsPage">
  <div class="m-4">
    <div class="row">
      <div class="col-6">
        <span (click)="resetAeForm()" class="cursor-pointer">
          <img src="assets/images/back-icon.svg" alt="back icon"> Back
        </span>
      </div>
      <div class="col-6 text-right"></div>
    </div>
  </div>
  <div class="m-4 p-4 border rounded reviewStatus" *ngIf="aeRemarks" [ngClass]="{
      'statusReject': aeCurrentStatus === aeStatus.REJECTED,
      'statusApproved': aeCurrentStatus === aeStatus.APPROVED,
      'statusReReview': aeCurrentStatus === aeStatus.RE_REVIEW || aeCurrentStatus === aeStatus.REVIEWED
    }">
    <p *ngIf="aeCurrentStatus !== aeStatus.REVIEWED" class="fnt-size18px font-weight-bold reviewStatus__heading">
      {{aeRemarks?.info![0]}}
    </p>
    <div *ngFor="let remark of aeRemarks?.info; index as i">
      <p *ngIf="i !== 0" class="mb-0 fnt-size16px">{{remark}}</p>
    </div>
    <div class="mt-2 fnt-size12px reviewStatus__time d-flex">
      <span>
        <span *ngIf="aeCurrentStatus === aeStatus.REJECTED">
          {{'REJECTED' | translate }}
        </span>
        <span *ngIf="aeCurrentStatus === aeStatus.APPROVED">
          {{'APPROVED' | translate }}
        </span>
        <span *ngIf="aeCurrentStatus === aeStatus.RE_REVIEW">
          {{'REVIEW' | translate }} {{'REQUESTED' | translate }}
        </span>
        <span>{{'BY' | translate }} {{aeRemarks?.name}} </span>
        <span>{{'ON' | translate }} {{aeFormData?.updated_at | date:'dd MMM yyyy, hh:mm a'}}</span>
      </span>
    </div>
  </div>

  <!-- SINGLE FORM WRAPPER -->
  <form>
    <div class="p-4">
      <!-- Parent Form: reportData -->
      <div>

        <!-- SECTION 1: PATIENT DETAILS -->
        <div class="ae-report mt-3">
          <h5 class="fnt-size18px text-heading-grey mb-3">{{'PATIENT_DETAILS' | translate}}</h5>
          <div [formGroup]="patientForm">
            <div class="row">
              <div class="col-md-4" *ngIf="checkIfFieldExists('patientId')">
                <div class="form-group">
                  <label for="patientId" class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                    <span>
                      {{ 'PATIENT_ID' | translate}}
                      <span class="text-danger ml-1">*</span>
                    </span>
                  </label>
                  <div class="position-relative">
                    <input formControlName="patientId" type="number" class="form-control fnt-size14px"
                      (input)="searchPatient(patientForm.get('patientId')?.value)"
                      (keyup)="patientDetailsErrorMessages=''" [placeholder]="('ENTER_PATIENT_ID' | translate)"
                      dngxDigitOnly
                      [attr.disabled]="disabled || aeCurrentStatus === aeReportStatus.RE_REVIEW ? true:null" />
                  </div>
                  <div *ngIf="patientIdErr" class="text-danger fnt-size12px">
                    {{"PATIENT_ID_NOT_VALID" | translate}}
                  </div>
                  <div
                    *ngIf="patientForm.get('patientId')?.touched && patientForm.get('patientId')?.invalid && checkIfFieldIsMandatory('patientId')"
                    class="text-danger fnt-size12px">
                    {{ 'PATIENT_ID' | translate}} {{ "IS_REQUIRED" | translate }}
                  </div>
                  <div *ngIf="patientDetailsErrorMessages" class="text-danger fnt-size12px">
                    {{this.patientDetailsErrorMessages | capitalize : "sentenceCase" }}
                  </div>
                </div>
              </div>
              <div class="col-md-8" *ngIf="checkIfFieldExists('registeredProgram')">
                <div class="form-group">
                  <label for="" class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                    <span>
                      {{ 'REGISTERED_PROGRAM' | translate}}
                      <span class="text-danger" *ngIf="checkIfFieldIsMandatory('registeredProgram')">*</span>
                    </span>
                  </label>
                  <div class="position-relative program_dropdown">
                    <input formControlName="registeredProgramName" type="text" class="form-control fnt-size14px w-100"
                      [readonly]="true" [attr.disabled]="true"
                      [placeholder]="('REGISTERED_PROGRAM_NAME' | translate)" />
                  </div>
                  <div
                    *ngIf="patientForm.get('registeredProgramName')?.touched && patientForm.get('registeredProgramName')?.invalid && checkIfFieldIsMandatory('registeredProgram')"
                    class="text-danger fnt-size12px">
                    {{ 'REGISTERED_PROGRAM' | translate}} {{ "IS_REQUIRED" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- SECTION 3: REPORT DETAILS -->
        <div class="ae-report mt-3">
          <h5 class="fnt-size18px text-heading-grey mb-3">{{'REPORT_DETAILS' | translate}}</h5>
          <div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group" [formGroup]="reportForm">
                  <label for="interactionDate"
                    class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                    <span>
                      {{ 'INTERACTION_DATE' | translate}}
                      <span class="text-danger">*</span>
                    </span>
                  </label>
                  <div class="position-relative">
                    <div class="calendar-field w-100">
                      <p-calendar [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true" [touchUI]="false"
                        yearRange="1922:2030" [inline]="false" panelStyleClass="bg-white border"
                        [styleClass]="reportForm?.get('interactionDate')?.touched && reportForm?.get('interactionDate')?.invalid ? 'pcomponent-invalid w-100' : 'w-100'"
                        [inputStyleClass]="'form-control fnt-size12px fnt_Medium w-100 rounded'"
                        formControlName="interactionDate" placeholder="{{'SELECT_DATE' | translate}}"
                        dateFormat="dd M yy" [disabled]="disabled" (onSelect)="onDateSelect('interactionDate', $event)">
                      </p-calendar>
                    </div>
                  </div>
                  <div
                    *ngIf="reportForm?.get('interactionDate')?.touched && reportForm?.get('interactionDate')?.invalid"
                    class="text-danger fnt-size12px">
                    {{ 'INTERACTION_DATE' | translate}} {{ "IS_MANDATORY" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group" [formGroup]="reportForm">
                  <label for="interactionId"
                    class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                    <span>
                      {{ 'INTERACTION_ID' | translate}}
                    </span>
                  </label>
                  <div class="position-relative ">
                    <input formControlName="interactionId"  papAutoTrim type="text" class="form-control fnt-size14px"
                      [placeholder]="'ENTER_INTERACTION_ID' | translate" maxlength="20"
                      [attr.disabled]="disabled ? true : null" />
                  </div> 
                </div>
              </div>
              <div class="col-md-4" *ngIf="patientReportForm?.get('reportType')?.value === 'REDEMPTION'">
                <div class="form-group" [formGroup]="reportForm">
                  <label for="applicationReportCreated"
                    class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                    <span>
                      {{ 'APPLICATION_REPORT_CREATED' | translate}}
                      <span class="text-danger">*</span>
                    </span>
                  </label>
                  <select class="form-control fnt-size12px fnt_Medium bg-porcelain-white"
                    formControlName="applicationReportCreated" [attr.disabled]="disabled ? true : null">
                    <option value="" selected class="d-none">Select Option</option>
                    <option *ngFor="let option of yesNoOptions" [value]="option.id">{{option.name}}</option>
                  </select>
                  <div
                    *ngIf="reportForm?.get('applicationReportCreated')?.touched && reportForm?.get('applicationReportCreated')?.invalid"
                    class="text-danger fnt-size12px">
                    {{ 'APPLICATION_REPORT_CREATED' | translate}} {{ "IS_MANDATORY" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-md-4" *ngIf="patientReportForm?.get('reportType')?.value === 'REDEMPTION'">
                <div class="form-group" [formGroup]="reportForm">
                  <label for="applicationReportId"
                    class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                    <span>
                      {{ 'APPLICATION_REPORT_ID' | translate}}
                      <span class="text-danger">*</span>
                    </span>
                  </label>
                  <div class="position-relative">
                    <input type="text" class="form-control fnt-size14px" papAutoTrim formControlName="applicationReportId"
                      [placeholder]="'ENTER_APPLICATION_REPORT_ID' | translate"
                      [attr.disabled]="disabled ? true : null" />
                    <div
                      *ngIf="reportForm?.get('applicationReportId')?.touched && reportForm?.get('applicationReportId')?.invalid"
                      class="text-danger fnt-size12px">
                      {{ 'APPLICATION_REPORT_ID' | translate}} {{ "IS_MANDATORY" | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4" *ngIf="patientReportForm?.get('reportType')?.value === 'REDEMPTION'">
                <div class="form-group" [formGroup]="reportForm">
                  <label for="testDate" class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                    <span>
                      {{ 'TEST_DATE' | translate}}
                      <span class="text-danger">*</span>
                    </span>
                  </label>
                  <div class="position-relative">
                    <div class="calendar-field w-100">
                      <p-calendar [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true" [touchUI]="false"
                        yearRange="1922:2030" [inline]="false" panelStyleClass="bg-white border"
                        [styleClass]="reportForm?.get('testDate')?.touched && reportForm?.get('testDate')?.invalid ? 'pcomponent-invalid w-100' : 'w-100'"
                        [inputStyleClass]="'form-control fnt-size12px fnt_Medium w-100 rounded'" [disabled]="disabled"
                        formControlName="testDate" placeholder="{{'SELECT_DATE' | translate}}" dateFormat="dd M yy"
                        (onSelect)="onDateSelect('testDate', $event)">
                      </p-calendar>
                    </div>
                  </div>
                  <div *ngIf="reportForm?.get('testDate')?.touched && reportForm?.get('testDate')?.invalid"
                    class="text-danger fnt-size12px">
                    {{ 'TEST_DATE' | translate}} {{ "IS_MANDATORY" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-md-4" *ngIf="patientReportForm?.get('reportType')?.value === 'REDEMPTION'">
                <div class="form-group" [formGroup]="reportForm">
                  <label for="invoiceDate" class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                    <span>
                      {{ 'INVOICE_DATE' | translate}}
                      <span class="text-danger">*</span>
                    </span>
                  </label>
                  <div class="position-relative">
                    <div class="calendar-field w-100">
                      <p-calendar [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true" [touchUI]="false"
                        yearRange="1922:2030" [inline]="false" panelStyleClass="bg-white border"
                        [styleClass]="reportForm?.get('invoiceDate')?.touched && reportForm?.get('invoiceDate')?.invalid ? 'pcomponent-invalid w-100' : 'w-100'"
                        [inputStyleClass]="'form-control fnt-size12px fnt_Medium w-100 rounded'"
                        formControlName="invoiceDate" placeholder="{{'SELECT_DATE' | translate}}" dateFormat="dd M yy"
                        [disabled]="disabled"
                        (onSelect)="onDateSelect('invoiceDate', $event)">
                      </p-calendar>
                    </div>
                  </div>
                  <div *ngIf="reportForm?.get('invoiceDate')?.touched && reportForm?.get('invoiceDate')?.invalid"
                    class="text-danger fnt-size12px">
                    {{ 'INVOICE_DATE' | translate}} {{ "IS_MANDATORY" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-md-4" *ngIf="patientReportForm?.get('reportType')?.value === 'REDEMPTION'">
                <div class="form-group" [formGroup]="patientReportForm">
                  <label for="invoiceNumber"
                    class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                    <span>
                      {{ 'INVOICE_NUMBER' | translate}}
                      <span class="text-danger">*</span>
                    </span>
                  </label>
                  <div class="position-relative">
                    <input type="text" class="form-control fnt-size14px"  papAutoTrim formControlName="invoiceNumber"
                      [placeholder]="'ENTER_INVOICE_NUMBER' | translate" [attr.disabled]="disabled ? true : null" />
                    <div
                      *ngIf="patientReportForm?.get('invoiceNumber')?.touched && patientReportForm?.get('invoiceNumber')?.invalid"
                      class="text-danger fnt-size12px">
                      {{ 'INVOICE_NUMBER' | translate}} {{ "IS_MANDATORY" | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4" *ngIf="patientReportForm?.get('reportType')?.value === 'REDEMPTION'">
                <div class="form-group" [formGroup]="reportForm">
                  <label for="reimbursementNumber"
                    class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                    <span>
                      {{ 'NO_OF_REIMBURSEMENT' | translate}}
                      <span class="text-danger">*</span>
                    </span>
                  </label>
                  <div class="position-relative">
                    <input type="text" class="form-control fnt-size14px" papAutoTrim formControlName="reimbursementNumber"
                      [placeholder]="'ENTER_NO_OF_REIMBURSEMENT' | translate"
                      [attr.disabled]="disabled ? true : null" />
                    <div
                      *ngIf="reportForm?.get('reimbursementNumber')?.touched && reportForm?.get('reimbursementNumber')?.invalid"
                      class="text-danger fnt-size12px">
                      {{ 'NO_OF_REIMBURSEMENT' | translate}} {{ "IS_MANDATORY" | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4" *ngIf="patientReportForm?.get('reportType')?.value === 'REDEMPTION'">
                <div class="form-group" [formGroup]="patientReportForm">
                  <label for="invoiceAmount"
                    class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                    <span>
                      {{ 'REIMBURSEMENT_AMOUNT' | translate}}{{'IN_THB' | translate}}
                      <span class="text-danger">*</span>
                    </span>
                  </label>
                  <div class="position-relative reimbursement-amount-container">
                    <input type="text" class="form-control fnt-size14px reimbursement-amount-input" papAutoTrim formControlName="invoiceAmount"
                      [placeholder]="'ENTER_REIMBURSEMENT_AMOUNT' | translate" (input)="userInput('invoiceAmount', $event)"
                      [attr.disabled]="disabled ? true : null" />
                    <select class="form-control fnt-size12px fnt_Medium bg-porcelain-white reimbursement-amount-unit"
                      formControlName="reimbursementAmountUnit" [attr.disabled]="disabled ? true : null">
                      <option value="" selected class="d-none">Select Option</option>
                      <option *ngFor="let option of amountUnit" [value]="option.id" [selected]="option.id === 'THB'">
                        {{option.name}}</option>
                    </select>
                  </div>
                  <div
                      *ngIf="patientReportForm?.get('invoiceAmount')?.touched && patientReportForm?.get('invoiceAmount')?.invalid"
                      class="text-danger fnt-size12px">
                      {{ 'REIMBURSEMENT_AMOUNT' | translate}} {{ "IS_MANDATORY" | translate }}
                    </div>
                </div>
              </div>
              <div class="col-md-4" *ngIf="patientReportForm?.get('reportType')?.value === 'REDEMPTION'">
                <div class="form-group" [formGroup]="reportForm">
                  <label for="continueTreatment"
                    class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                    <span>
                      {{ 'CONTINUE_TREATMENT_AFTER_CT_SCAN' | translate}}
                      <span class="text-danger">*</span>
                    </span>
                  </label>
                  <select class="form-control fnt-size12px fnt_Medium bg-porcelain-white"
                    formControlName="continueTreatment" [attr.disabled]="disabled ? true : null">
                    <option value="" selected class="d-none">Select Option</option>
                    <option *ngFor="let option of yesNoOptions" [value]="option.id">{{option.name}}</option>
                  </select>
                  <div
                    *ngIf="reportForm?.get('continueTreatment')?.touched && reportForm?.get('continueTreatment')?.invalid"
                    class="text-danger fnt-size12px">
                    {{ 'CONTINUE_TREATMENT_AFTER_CT_SCAN' | translate}} {{ "IS_MANDATORY" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-md-4" *ngIf="patientReportForm?.get('reportType')?.value === 'REDEMPTION'">
                <div class="form-group" [formGroup]="reportForm">
                  <label for="aeFromCtScan"
                    class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                    <span>
                      {{ 'ANY_AE_FROM_CT_SCAN' | translate}}
                      <span class="text-danger">*</span>
                    </span>
                  </label>
                  <select class="form-control fnt-size12px fnt_Medium bg-porcelain-white" formControlName="aeFromCtScan"
                    [attr.disabled]="disabled ? true : null">
                    <option value="" selected class="d-none">Select Option</option>
                    <option *ngFor="let option of yesNoOptions" [value]="option.id">{{option.name}}</option>
                  </select>
                  <div *ngIf="reportForm?.get('aeFromCtScan')?.touched && reportForm?.get('aeFromCtScan')?.invalid"
                    class="text-danger fnt-size12px">
                    {{ 'ANY_AE_FROM_CT_SCAN' | translate}} {{ "IS_MANDATORY" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-md-4"
                *ngIf="patientReportForm?.get('reportType')?.value === 'REDEMPTION' && reportForm?.get('aeFromCtScan')?.value === 'YES'">
                <div class="form-group" [formGroup]="reportForm">
                  <label for="aeReportNumber"
                    class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                    <span>
                      {{ 'IF_YES_AE_REPORT_NUMBER' | translate}}
                    </span>
                  </label>
                  <div class="position-relative">
                    <input type="text" class="form-control fnt-size14px" papAutoTrim formControlName="aeReportNumber"
                      [placeholder]="'ENTER_AE_REPORT_NUMBER' | translate" [attr.disabled]="disabled ? true : null" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ae-report mt-3">
          <pap-relevant-laboratory-test-data-form [isPatientReport]="true" [functionality]="pageFunctionality"
            [formData]="patientReportForm?.get('relevantLabTestForm')?.value" [process]="process" #childForms
            (emitRelevantData)="onEmitRelevantData($event)"></pap-relevant-laboratory-test-data-form>
        </div>

        <div class="ae-report mt-3" *ngIf="aeCurrentStatus === aeStatus.APPROVED">
          <h5 class="fnt-size18px text-heading-grey mb-3">
            Transaction Details
          </h5>
          <div class="row" [formGroup]="transactionForm">
            <div class="col-md-6" *ngIf="reportType === 'REDEMPTION'">
              <div class="form-group">
                <label for="transactionDate"
                  class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                  <span>Transaction Date <span class="text-danger">*</span>
                  </span>
                </label>
                <div class="position-relative">
                  <div class="calendar-field w-100">
                    <p-calendar [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true" [touchUI]="false"
                      yearRange="1922:2030" [inline]="false" panelStyleClass="bg-white border"
                      [styleClass]="reportForm?.get('transactionDate')?.touched && reportForm?.get('transactionDate')?.invalid ? 'pcomponent-invalid w-100' : 'w-100'"
                      [inputStyleClass]="'form-control fnt-size12px fnt_Medium w-100 rounded'"
                      formControlName="transactionDate" placeholder="{{'SELECT_DATE' | translate}}" dateFormat="dd M yy"
                      [disabled]="true">
                    </p-calendar>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="reportType === 'REDEMPTION'">
              <div class="form-group">
                <label for="transactionCode"
                  class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                  <span> Transaction Code <span class="text-danger">*</span>
                  </span>
                </label>
                <div class="position-relative ">
                  <input formControlName="transactionCode" type="text" class="form-control fnt-size14px"
                    [placeholder]="'Transaction Code'" maxlength="20" [attr.disabled]="true" />
                </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="reportType !== 'REDEMPTION'">
              <div class="form-group">
                <label for="bankDetailsApprovalDate"
                  class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                  <span>Date of Approved Bank Information <span class="text-danger">*</span>
                  </span>
                </label>
                <div class="position-relative">
                  <div class="calendar-field w-100">
                    <p-calendar [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true" [touchUI]="false"
                      yearRange="1922:2030" [inline]="false" panelStyleClass="bg-white border"
                      [styleClass]="reportForm?.get('bankDetailsApprovalDate')?.touched && reportForm?.get('bankDetailsApprovalDate')?.invalid ? 'pcomponent-invalid w-100' : 'w-100'"
                      [inputStyleClass]="'form-control fnt-size12px fnt_Medium w-100 rounded'"
                      formControlName="bankDetailsApprovalDate" placeholder="{{'SELECT_DATE' | translate}}"
                      dateFormat="dd M yy" [disabled]="true">
                    </p-calendar>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="reportType !== 'REDEMPTION'">
              <div class="form-group">
                <label for="patientConsentDate"
                  class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                  <span>Date of Patient Consent <span class="text-danger">*</span>
                  </span>
                </label>
                <div class="position-relative">
                  <div class="calendar-field w-100">
                    <p-calendar [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true" [touchUI]="false"
                      yearRange="1922:2030" [inline]="false" panelStyleClass="bg-white border"
                      [styleClass]="reportForm?.get('patientConsentDate')?.touched && reportForm?.get('patientConsentDate')?.invalid ? 'pcomponent-invalid w-100' : 'w-100'"
                      [inputStyleClass]="'form-control fnt-size12px fnt_Medium w-100 rounded'"
                      formControlName="patientConsentDate" placeholder="{{'SELECT_DATE' | translate}}"
                      dateFormat="dd M yy" [disabled]="true">
                    </p-calendar>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="reportType !== 'REDEMPTION'">
              <div class="form-group">
                <label for="consentLink" class="mb-1 text-secondary-grey fnt-size14px d-flex justify-content-between">
                  <span> Consent Link <span class="text-danger">*</span>
                  </span>
                </label>
                <div class="position-relative ">
                  <input formControlName="consentLink" type="text" class="form-control fnt-size14px"
                    [placeholder]="'Transaction Code'" maxlength="20" [attr.disabled]="true" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FORM ACTION BUTTONS -->
    <!-- ... buttons remain the same ... -->
    <div class="d-flex p-4">
      <div class="w-50">
        <button *ngIf="userRole === userType.PAP_SUPERVISOR" [disabled]="aeCurrentStatus !== aeStatus.REVIEWED"
          class="btn btn-outline-danger" (click)="userActionForRejection=true">
          {{'REJECT'| translate}}
        </button>
      </div>
      <div class="d-flex justify-content-end w-50">
        <button *ngIf="userRole === userType.PAP_SUPERVISOR" [disabled]="aeCurrentStatus !== aeStatus.REVIEWED"
          class="btn btn-outline-success mx-4" (click)="userActionForSendForReview=true">
          {{'SEND_FOR_REVIEW'| translate}}
        </button>
        <button *ngIf="userRole === userType.PAP_SUPERVISOR"
          [disabled]="aeCurrentStatus !== aeStatus.REVIEWED || changeStatusLoader" class="btn btn-success"
          (click)="updateStatus(aeStatus.APPROVED, '')">
          <div class="spinner-border text-light" role="status" *ngIf="changeStatusLoader">
          </div>
          <span *ngIf="!changeStatusLoader">{{'APPROVE'| translate}}</span>
        </button>
        <button *ngIf="!userRole || userRole === userType.APPROVER" class="btn btn-success" type="submit"
          [disabled]="!updateFormValidity() || changeStatusLoader || disabled" (click)="aeReportSubmit()">
          <div class="spinner-border text-light" role="status" *ngIf="changeStatusLoader">
          </div>
          <span *ngIf="!changeStatusLoader">{{'SUBMIT'
            | translate}}</span>
        </button>
      </div>
    </div>
  </form>

  <!-- MODALS (outside form) -->
  <!-- ... modals remain the same ... -->

  <dngx-model class="sendForReviewApplication" [modalTitle]="'SEND_AE_FOR_REVIEW' | translate"
    [displayModal]="userActionForSendForReview" [dismissableMask]="false" [headerVisible]="true" [closable]="true"
    (hideModal)="userActionForSendForReview=false">
    <div class="pl-4 pr-4">
      <div class="pr-4">
        <textarea rows="4" class="custom-control w-100 reasonOthertextarea"
          placeholder="{{'ENTER_THE_REASON' | translate}}" [(ngModel)]="sendForReviewRemarks"></textarea>
      </div>
    </div>
    <hr>
    <div class="d-flex justify-content-end px-3 pb-3">
      <button class="btn btn-outline-success fnt-size12px px-3 py-1 mr-3" (click)="userActionForSendForReview=false"
        [disabled]="changeStatusLoader">{{'CANCEL'
        | translate}}</button>

      <button *ngIf="userRole === userType.PAP_SUPERVISOR"
        [disabled]="!sendForReviewRemarks?.trim() || changeStatusLoader" class="btn btn-success fnt-size12px px-3 py-1"
        (click)="updateStatus(aeStatus.RE_REVIEW, sendForReviewRemarks)">
        <div class="spinner-border text-light" role="status" *ngIf="changeStatusLoader">
        </div>
        <span *ngIf="!changeStatusLoader">{{'SUBMIT'
          | translate}}</span>
      </button>
    </div>
  </dngx-model>

  <dngx-model class="rejectApplication pt-0" [modalTitle]="'REJECT_REPORT' | translate"
    [displayModal]="userActionForRejection" [dismissableMask]="false" [headerVisible]="true" [closable]="true"
    (hideModal)="userActionForRejection=false">
    <div class="pl-4 pr-4">
      <div class="pr-4">
        <textarea rows="4" class="custom-control w-100 reasonOthertextarea"
          placeholder="{{'ENTER_THE_REASON' | translate}}" [(ngModel)]="rejectionRemarks"></textarea>
      </div>
    </div>
    <hr>
    <div class="d-flex justify-content-end px-3 pb-3">
      <button class="btn btn-outline-success fnt-size12px px-3 py-1 mr-3" (click)="userActionForRejection=false"
        [disabled]="changeStatusLoader">{{'CANCEL'
        | translate}}</button>

      <button *ngIf="userRole === userType.PAP_SUPERVISOR" [disabled]="!rejectionRemarks?.trim() || changeStatusLoader"
        class="btn btn-success fnt-size12px px-3 py-1" (click)="updateStatus(aeStatus.REJECTED, rejectionRemarks)">
        <div class="spinner-border text-light" role="status" *ngIf="changeStatusLoader">
        </div>
        <span *ngIf="!changeStatusLoader">{{'SUBMIT'
          | translate}}</span>
      </button>
    </div>
  </dngx-model>

  <dngx-model [displayModal]="isSuccessModal" [dismissableMask]="false" [headerVisible]="true" [closable]="true"
    (hideModal)="resetAeForm()" contentStyleClass="rounded-bottom p-0">
    <div>
      <div class="pb-4 text-center fnt-size20px text-danger">
        <img src="../../../../assets/images/success.svg" alt="">
      </div>
      <div class="text-center pb-4 pt-4">
        <span *ngIf="userActionForApproval"
          class="text-center fnt-size20px text-black font-weight-regular">{{'AE_REPORT_APPROVED' | translate}}
        </span>
        <span *ngIf="userActionForSubmit"
          class="text-center fnt-size20px text-black font-weight-regular">{{'AE_REPORT_SUBMITTED' | translate}}
        </span>
        <span *ngIf="userActionForSubmitError" class="text-center fnt-size20px text-black font-weight-regular">Unable to
          submit the report. Please try again later.
        </span>
        <span *ngIf="userActionForNotApprovedApplication"
          class="text-center fnt-size20px text-black font-weight-regular">
          Patient bank details are not verified.
        </span>
        <span *ngIf="userActionForExistingApplication" class="text-center fnt-size20px text-black font-weight-regular">
          Application already exists for the Patient.
        </span>
      </div>
    </div>
  </dngx-model>
</div>